"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditPage = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const PageHeader_1 = require("@juvare/common-web-ui/PageHeader");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const useAuditTable_1 = require("../hooks/useAuditTable");
const AuditDetailsDialog_1 = require("./AuditDetailsDialog");
const AuditPage = (props) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const { dataTableProps, clearActiveRow } = (0, useAuditTable_1.useAuditTable)({
        useDataTableFunction: DataTable_1.useDataTableUsingUrl,
        eventTypes: props.eventTypes,
        additionalEventTypes: props.additionalEventTypes,
        customAuditBackendDataProvider: props.customAuditBackendDataProvider,
        auditTags: props.auditTags,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PageHeader_1.PageHeader, { gradient: 'purple-base' },
            react_1.default.createElement(material_1.Typography, { variant: 'h4', sx: { p: 4 } }, t('audit.tableTitle'))),
        react_1.default.createElement(material_1.Box, { p: 4 },
            react_1.default.createElement(DataTable_1.DataTable, Object.assign({}, dataTableProps)),
            dataTableProps.activeRowId && (react_1.default.createElement(AuditDetailsDialog_1.AuditDetailsDialog, { id: dataTableProps.activeRowId, onClose: clearActiveRow, formatters: props.formatters })))));
};
exports.AuditPage = AuditPage;
